
    var riot = require('riot')
    //src: starling/src/tags/color-picker.html
riot.tag2('color-picker',
  '<div id="color-picker" riot-style="{this.positioning}" class="{this.type}-picker"> <div class="color-col"> <div each="{color in this.colors}"> <div data-color="{color}" class="color-button {this.checkSelectedColor(color) && \'selected\'}" riot-style="{this.getStyle(color)}" onclick="{this.handleSetColor}"></div> </div> </div> <ul if="{type === \'card\' || (this.type == \'bulk\' && opts.subject == \'card\')}" class="style-col" ref="displayStylePicker"> <li ref="stylePickAccent" class="style-pick style-pick--accent {styleSelected(\'accent\')}"> <button onclick="{this.handleSetStyle.bind(this,\'accent\')}">Fill</button> </li> <li ref="stylePickStandard" class="style-pick style-pick--standard {styleSelected(\'standard\')}"> <button onclick="{this.handleSetStyle.bind(this,\'standard\')}">Outline</button> </li> <li ref="stylePickLight" class="style-pick style-pick--light {styleSelected(\'light\')}"> <button onclick="{this.handleSetStyle.bind(this,\'light\')}">Fade</button> </li> </ul> <div if="{this.type == \'link\' || (this.type == \'bulk\' && opts.subject == \'relationship\')}" class="style-col"> <div class="line-button-container style {this.styleSelected(\'solid\')}" onclick="{this.handleSetType.bind(this,\'solid\')}"> <svg class="line-button style" height="4px"> <path d="M 0 2 L 40 2" stroke-width="4px"></path> </svg> </div> <div class="line-button-container style {this.styleSelected(\'dotted\')}" onclick="{this.handleSetType.bind(this,\'dotted\')}"> <svg class="line-button style" height="4px"> <path d="M 0 2 L 40 2" stroke-width="4px" stroke-dasharray="4px 4px"></path> </svg> </div> <div class="line-button-container style {this.styleSelected(\'dashed\')}" onclick="{this.handleSetType.bind(this,\'dashed\')}"> <svg class="line-button style" height="4px"> <path alignment-baseline="middle" d="M 0 2 L 40 2" stroke-width="4px" stroke-dasharray="9px 3px"></path> </svg> </div> </div> <div if="{this.type == \'link\' || (this.type == \'bulk\' && opts.subject == \'relationship\')}" class="width-col"> <div class="line-button-container {this.widthSelected(\'xs\')}" onclick="{this.handleSetWidth.bind(this,\'xs\')}"> <svg class="line-button" height="1.5px"> <rect class="rect" width="40px" height="1.5px"></rect> </svg> </div> <div class="line-button-container {this.widthSelected(\'s\')}" onclick="{this.handleSetWidth.bind(this,\'s\')}"> <svg class="line-button" height="3px"> <rect class="rect" width="40px" height="3px"></rect> </svg> </div> <div class="line-button-container {this.widthSelected(\'l\')}" onclick="{this.handleSetWidth.bind(this,\'l\')}"> <svg class="line-button" height="6px"> <rect class="rect" width="40px" height="6px"></rect> </svg> </div> <div class="line-button-container {this.widthSelected(\'xl\')}" onclick="{this.handleSetWidth.bind(this,\'xl\')}"> <svg class="line-button" height="8px"> <rect class="rect" width="40px" height="8px"></rect> </svg> </div> </div> </div>',
  '',
  'onmouseenter="{this.handlePanelMouseEnter}" onclick="{ignoreClick}"', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

var _util = require('lib/util');

var _delayHandler = require('lib/delay-handler');

function hexToRGBA(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);

  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
}

this.colors = opts.colors;
this.type = opts.type;
this.setColor = opts.setcolor;
this.setLinkType = opts.setlinetype;
this.setLinkWidth = opts.setlinewidth;
this.positioning = opts.positioning || '';
this.canvas = this.parent.canvas;

this.on('mount', function () {
  _this.setStylePickerColor();
});

this.on('update', function () {
  _this.setStylePickerColor();
});

this.setStylePickerColor = function () {
  if (!_this.refs.displayStylePicker) return;

  var _opts = opts,
      color = _opts.selectedcolor;

  color = color || '#3c444f';

  var _refs = _this.refs,
      stylePickAccent = _refs.stylePickAccent,
      stylePickStandard = _refs.stylePickStandard,
      stylePickLight = _refs.stylePickLight;

  stylePickAccent.style = (0, _util.getStyleColorVariables)({ color: color, style: 'accent' });
  stylePickStandard.style = (0, _util.getStyleColorVariables)({ color: color, style: 'standard' });
  stylePickLight.style = (0, _util.getStyleColorVariables)({ color: color, style: 'light' });
};

this.ignoreClick = function (e) {
  e.stopPropagation();
};

this.handleSetColor = function (e) {
  e.stopPropagation();
  _this.setColor(e.item.color);
  _this.update();
};

this.handleSetStyle = function (style, e) {
  e.stopPropagation();
  _this.parent.setDisplayStyle({ style: style });
  _this.update();
};

this.handleSetType = function (type, e) {
  e.stopPropagation();
  _this.setLinkType(type);
  _this.update();
};

this.handleSetWidth = function (width, e) {
  e.stopPropagation();
  _this.setLinkWidth(width);
  _this.update();
};

this.checkSelectedColor = function (swatchColorHex) {
  var _opts2 = opts,
      type = _opts2.type,
      selectedcolor = _opts2.selectedcolor;

  var currentColor = void 0,
      swatchColor = void 0;

  if (type === 'card' || selectedcolor) {
    currentColor = selectedcolor ? selectedcolor.toString().toLowerCase() : null;
    swatchColor = swatchColorHex.toString().toLowerCase();
  } else if (type === "tag" && _this.parent.color) {
    currentColor = _this.parent.color.toString().toLowerCase();
    swatchColor = swatchColorHex.toString().toLowerCase();
  } else if (type === "link") {
    currentColor = _this.parent.link.color;
    swatchColor = _constants.LINK_COLORS_MAPPING[swatchColorHex];
  } else if (type === 'bulk') {
    currentColor = _this.parent.getBulkColor();
    if (!currentColor) {
      return false;
    }
    swatchColor = _constants.LINK_COLORS_MAPPING[swatchColorHex];
  } else {
    return false;
  }
  return currentColor === swatchColor;
};

this.getStyle = function (color) {
  var style = 'background: ' + color + ';';
  if (_this.checkSelectedColor(color)) {
    _this.hexColor = color;
    return style + ('box-shadow: 0 0 0px 3px ' + hexToRGBA(color, 50) + ';');
  } else {
    return style;
  }
};

this.getCurrentColor = function () {
  return _this.hexColor;
};

this.styleSelected = function (style) {
  var _opts3 = opts,
      type = _opts3.type,
      selectedstyle = _opts3.selectedstyle;

  if (type === 'card' || selectedstyle) {
    return selectedstyle === style ? 'style-pick--selected' : '';
  } else if (type == 'bulk') {
    var bulkType = _this.parent.getBulkLineType();
    if (bulkType && bulkType == style) {
      return 'selected';
    }
  } else if (opts.linkid && store.getLink(opts.linkid).lineType == style) {
    return 'selected';
  }
  return '';
};

this.widthSelected = function (width) {
  if (_this.type == 'bulk') {
    var bulkWidth = _this.parent.getBulkLineWidth();
    if (bulkWidth && bulkWidth == width) {
      return 'selected';
    }
  } else if (opts.linkid && store.getLink(opts.linkid).lineWidth == width) {
    return 'selected';
  }
  return '';
};

this.handlePanelMouseEnter = function () {
  _delayHandler.delayHandler.clearDelayFor('submenus');
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('color-picker')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/color-picker.html
// module id = 598
// module chunks = 0